"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.URL_TYPES = void 0;
var URL_TYPES;
(function (URL_TYPES) {
    URL_TYPES["VIDEO"] = "video";
    URL_TYPES["CHANNEL"] = "channel";
    URL_TYPES["USER_NAME"] = "username";
    URL_TYPES["PLAYLIST"] = "playlist";
})(URL_TYPES = exports.URL_TYPES || (exports.URL_TYPES = {}));
//# sourceMappingURL=url-types.js.map